// import { StrictMode } from 'react'
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import "./index.css";
import { AppErrorBoundary } from "./components/AppErrorBoundary/index.tsx";
import GenericError from "./components/GenericError/index.tsx";
import { reportError } from "./utils/reportError.ts";
import { initAppInsights } from "./utils/monitoring/appInsights.ts";

// See docs/application-insights-rum.md.
initAppInsights();

createRoot(document.getElementById("root")!, {
  onUncaughtError(error, errorInfo) {
    reportError(error as Error, {
      eventName: "FE-ERROR-ON_CAUGHT",
      errorCode: "react.onUncaughtError",
      errorMessage: errorInfo.componentStack,
    });
  },
  onRecoverableError(error, errorInfo) {
    reportError(error as Error, {
      eventName: "FE-ERROR-ON_RECOVERABLE",
      errorCode: "react.onRecoverableError",
      errorMessage: errorInfo.componentStack,
    });
  },
}).render(
  <AppErrorBoundary fallback={<GenericError />}>
    <App />
  </AppErrorBoundary>,
);
